import { useEffect, useState } from 'react'
import { useFormState } from 'react-hook-form'

export const useFormSectionCollapsible = (
	fieldNames: readonly string[],
	defaultOpen = false,
) => {
	const { errors } = useFormState()
	const [open, setOpen] = useState(defaultOpen)
	const hasErrors = fieldNames.some((fieldName) => fieldName in errors)

	useEffect(() => {
		if (hasErrors) setOpen(true)
	}, [hasErrors])

	return {
		hasErrors,
		onOpenChange: setOpen,
		open,
	}
}
